import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PayerError } from '@payer-admin-ui/components/src/utils/errors';
import { toPayerError } from 'utils/rtk';
import { sessionAPI } from './sessionAPI';
import { setSession } from './session';
import { loadUserSettings } from './userSettings';
import { MerchantAdminDispatch, MerchantAdminState } from './store';

export type LoginCredentialsState = {
  error: PayerError | null;
};

export const loginWithCredentials = createAsyncThunk<
  void,
  { clientId: string; clientSecret: string },
  { state: MerchantAdminState; dispatch: MerchantAdminDispatch }
>('login/credentials/login', async ({ clientId, clientSecret }, { dispatch }) => {
  const session = await sessionAPI.loginCredentials({ clientId, clientSecret });
  dispatch(setSession(session));
  dispatch(loadUserSettings());
});

const initialState: LoginCredentialsState = {
  error: null,
};

const loginCredentialsSlice = createSlice({
  name: 'login/credentials',
  initialState,
  reducers: {
    resetError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(loginWithCredentials.pending, () => ({ ...initialState }));
    builder.addCase(loginWithCredentials.rejected, (state, { error }) => ({
      ...initialState,
      error: toPayerError(error),
    }));
  },
});

export const {
  actions: { resetError },
  reducer: loginCredentialsReducer,
} = loginCredentialsSlice;
